import { useTranslation } from "react-i18next"
import * as React from "react"

export const Map: React.FC = () => {
  const { t, i18n: i18next } = useTranslation("translations", { keyPrefix: "INDEX.MAP" })


  return (
    <div className="row text-center w-100 mx-auto" style={{backgroundColor: "#6c2c2f"}}>
      <div className="col-md-3 p-0 my-auto">
        <div className="text-light p-4">
          <h1>MAP</h1>
          <small>{t("SUBTITLE")}</small>
          <p className="mt-3 mb-1">{t("DESC_1")}</p>
          <p className="m-0">{t("DESC_2")}</p>
        </div>
      </div>
      <div className="col-md-9 p-4">
        <iframe title="Google Maps" src={`https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d815.3284164732432!2d136.8956880699523!3d35.17373394954942!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x600376d6b02a9ebd%3A0xb4f53f870d205616!2z5qCq5byP5Lya56S-44Ko44Og44Kx44Kk44K344K544OG44Og!5e0!3m2!1sja!2sjp!4v1560529093078!5m2!1s${i18next.language}!2sjp`} height="420" frameBorder="0" className="w-100 border-0" allowFullScreen></iframe>
      </div>
    </div>
  )
}
